<template>
  <div class="home_container" :style="{backgroundImage: ListBgc}">
    <div class="header_container">
      <div class="logo">
      </div>
      <div class="centerBtn"></div>
      <div class="rightBtn">
        <div class="myGiftBtn" @click="$router.go(-1)">
          <div class="btn_inner" :style="{background: btnBgcColor, color: btnFontColor}">返回</div>
        </div>
      </div>
      <div class="rightIcon"></div>
    </div>
    <div class="ruleTitle">
      <van-row class="m_b5" :style="{marginTop: cardFromTheTopValue}">
        <van-col span="24" class="c_w m_b35">
          <!--type 类型 0:优惠卷 1:实体 -->
          <!-- fillIn 类型为0 是否加入卡包 类型为1 是否填写收货地址 -->
          <div class="allOfOne" v-for="(item, i) in myGifttAll" :key="i" v-show="loadingFlag==='0'" :style="{backgroundColor: cardBgc}">
            <div class="content_containerBox">
              <!-- new css start: -->
              <div class="card_title" :style="{color: btnFontColor}">
                {{item.giftName}}
              </div>
              <div class="card_body">
                <div class="card_content">
                  <img :src="item.imgUrl" alt="">
                </div>
                <div class="card_footer">
                  <div class="card_footer_btn" :style="{background: btnBgcColor, color: btnFontColor}" @click="goLook()" v-if="(item.type===1 && item.fillIn===true) || (item.type===0 && item.fillIn===true)">点击查看</div>
                  <div class="card_footer_btn" :style="{background: btnBgcColor, color: btnFontColor}" @click="toAddCard" v-else-if="item.type===0 && item.fillIn===false">加入卡包</div>
                  <div class="card_footer_btn" :style="{background: btnBgcColor, color: btnFontColor}" @click="toWritePage(item.callbackUuid)" v-else-if="item.type===1 && item.fillIn===false">填写信息</div>
                </div>
              </div>
              <!-- new css end -->
            </div>
          </div>

          <div class="loadingBox" v-show="loadingFlag==='1'">
            <div class="content_loadingBox">
              <img :src="require(`../../assets/image/rider.gif`)" alt="">
            </div>
          </div>
          <div class="allNull" v-show="loadingFlag==='2'">
            <div class="content_loadingBox">
              <img src="../../assets/image/riderTip.24cbcc1b.png" alt="">
              <p>暂无数据哦！</p>
            </div>
          </div>
        </van-col>
      </van-row>
    </div>

    <!-- 注册弹框： -->
    <transition name="myself-dialog-fade">
      <div class="showBox_father" v-if="dialogShow" @click="hideMask()">
        <div class="showBox_son" :style="{backgroundColor: cardBgc}" @click.stop>
          <div class="dialogBox_inner">
            <!-- <div class="dialogBox_inner_title" :style="{color: btnFontColor}">轻松绑定，优惠券即可自动放入您的达美乐卡包！</div> -->
            <div class="dialogBox_inner_title" :style="{color: btnFontColor}">轻松注册达美乐账户，立即前往卡包享受优惠福利！</div>
            <div class="dialogBox_inner_input_box">
              <div class="new_content_input" :style="{border: `1px solid ${btnBgcColor}`}">
                <div class="new_content_input_box_inner">
                  <van-field v-model.trim="phoneNumber" placeholder="请输入手机号"  @blur="onBlurInput()" />
                </div>
              </div>
              <div class="new_content_input" :style="{border: `1px solid ${btnBgcColor}`}">
                <div class="new_content_input_box_inner">
                  <van-field v-model.trim="phoneCode" placeholder="验证码"  @blur="onBlurInput()" maxlength="6" />
                </div>
                <div class="new_content_input_box_inner_getCodeBtn" :style="{borderLeft: `1px solid ${btnBgcColor}`, color: btnFontColor}" @click="getPhoneCode">{{verifycodeBtnText}}</div>
              </div>
            </div>
            <div class="dialogBox_inner_footer">
              <div class="checkbox_container">
                <!-- <van-checkbox v-model="checkedAboutAlert"><span :style="{color: btnFontColor}">已阅读并同意</span></van-checkbox> -->
                <div class="checkbox_container_btn" @click="checkedAboutAlert = !checkedAboutAlert">
                  <div class="no_active" v-if="!checkedAboutAlert" :style="{border: `1px solid ${btnBgcColor}`}"></div>
                  <div class="active" v-if="checkedAboutAlert" :style="{backgroundColor: `${btnBgcColor}`}">
                    <span class="iconfont icon-gougou" :style="{color: btnFontColor}"></span>
                  </div>
                  <div  :style="{color: btnFontColor}">已阅读并同意</div>
                </div>
                <span class="checkbox_container_text" :style="{color: btnFontColor}" @click="goAgreementUser">《用户协议》,</span>
                <span class="checkbox_container_text" :style="{color: btnFontColor}" @click="goAgreementPrivacy">《个人信息保护政策》</span>
              </div>
              <div class="btn_container">
                <div class="btn_inner" @click="hideMask" :style="{background: btnBgcColor, color: btnFontColor}">取消</div>
                <div class="btn_inner" @click="registerBtn"  :style="{background: btnBgcColor, color: btnFontColor}">确认</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!-- 用户协议：隐私协议： -->
    <transition name="myself-dialog-fade">
      <div class="showBox_father" v-if="dialogShowByUserOrPrivacy" @click="dialogShowByUserOrPrivacy = false">
        <div class="showBox_son showBox_son_by_user" :style="{backgroundColor: cardBgc}" @click.stop>
            <div class="showBox_son_by_user_content">
              <iframe :src="iframeSrc" frameborder="0"></iframe>
            </div>
            <div class="showBox_son_by_user_btn">
              <div class="btn_inner" @click="dialogShowByUserOrPrivacy = false"  :style="{background: btnBgcColor, color: btnFontColor}">关闭</div>
            </div>
        </div>
      </div>
    </transition>

    <!--  @*易盾滑动验证码*@  -->
    <div id="captcha"></div>

  </div>
</template>

<script>
import { Toast } from "vant";
import URL from "@/utils/url";
import { mapMutations, mapGetters } from "vuex";
import { comment } from "@/mixins/comment.js";
import { encodeToUrl } from "@/utils/enDeCode.js";
import yidunPopup from "@/utils/yiduncomm.js";
import devicetype from "@/utils/deviceType.js";
export default {
  mixins: [comment],
  data() {
    return {
      myGifttAll: [],
      loadingFlag: '1',
      dialogShow: false,
      phoneNumber: "",
      phoneCode: "",
      expofPhone: /^1[3-9]\d{9}$/,
      verifycodeBtnText: "获取验证码",
      getCodeState: true,
      checkedAboutAlert: false,

      dialogShowByUserOrPrivacy: false,
      iframeSrc: "",
      NECaptchaValidate: null,
      cid: ""
    };
  },
  methods: {
    ...mapMutations([
      'SET_GroundMarketingInfo',
    ]),
    async registerBtn() {
      if (this.phoneNumber === "") return Toast("手机号不能为空");
      if (!this.expofPhone.test(this.phoneNumber)) return Toast("手机号格式不正确");
      if (this.phoneCode === "") return Toast("验证码不能为空");
      if (!this.checkedAboutAlert) return Toast("请阅读并同意用户协议及个人信息保护政策");
      try {
        let params = {
          cellPhone: this.phoneNumber,
          isNew: 1,
          randomNum: this.phoneCode,
          requestSource: devicetype().name,
          pageCode: "login_page",
          caller: "luckDraw",
        }
        let {data: result} = await this.$post('login', params);
        if (result.code !== 200) return Toast(result.errMsg);
        // 这里需要再次存储用户信息：
        // console.log(getGroundMarketingInfo);
        let info = {
          userInfo: {
            phone: this.phoneNumber,
            code: this.phoneCode,
            isNew: 0,
            ...result.data
          },
          actInfo: this.getGroundMarketingInfo.actInfo
        }
        if (this.getGroundMarketingInfo.source) Object.assign(info, {source: this.getGroundMarketingInfo.source});
        this.SET_GroundMarketingInfo(info);
        let url = "";
        if (this.getGroundMarketingInfo.source) {
          url = this.$linkURL + 'my/coupon/list' + '/?receiveinfo=' + encodeToUrl({ token: result.data.token}) + '&utm_source=' + this.getGroundMarketingInfo.source;
        } else {
          url = this.$linkURL + 'my/coupon/list' + '/?receiveinfo=' + encodeToUrl({ token: result.data.token});
        }
        top.window.location.href = url;
      } catch(err) {
        console.log(err);
      }
    },
    goAgreementUser() {
      // way one:
      // Toast.loading({
      //   message: "正在加载",
      //   forbidClick: true,
      //   duration: 0
      // });
      // top.window.location.href = 'https://meituan.nr.junde.co/UserAgreement';
      // way two:
      this.iframeSrc = 'https://meituan.nr.junde.co/UserAgreement';
      this.dialogShowByUserOrPrivacy = true;
    },
    goAgreementPrivacy() {
      // way one:
      // Toast.loading({
      //   message: "正在加载",
      //   forbidClick: true,
      //   duration: 0
      // });
      // top.window.location.href = 'https://meituan.nr.junde.co/PrivacyProtocol';
      // way two:
      this.iframeSrc = 'https://meituan.nr.junde.co/PrivacyProtocol';
      this.dialogShowByUserOrPrivacy = true;
    },
    onBlurInput() {
		  window.scroll(0, 0);
    },
    hideMask() {
      this.dialogShow = false; 
    },
    // 验证码：
    async getPhoneCode() {
      if (this.phoneNumber == "") return Toast("手机号不能为空");
      if (!this.expofPhone.test(this.phoneNumber)) return Toast("手机号格式不正确");
      let sendRandomNumParams = {
        requestSource: devicetype().name,
        pageCode: "login_page",
        caller: "luckDraw",
        NECaptchaValidate: this.NECaptchaValidate,
        phoneNumber: this.phoneNumber,
        actId: this.actInfo.id
      }
      // 倒计时初始化：
      let codeTime = 60;
      // 节流阀：
      if (!this.getCodeState) return;
      this.verifycodeBtnText = "正在发送";
      let {data: result} = await this.$post(`/consumer/user/sendRandomNum`, sendRandomNumParams);
      this.NECaptchaValidate = null;
      if (result.code !== 200) {
        if (result.data.errCode === '400235') {
          let _that = this;
          // 滑动验证码校验成功后的处理方法：
          yidunPopup(function(err, data) {
            if (err) {
              _that.NECaptchaValidate = null;
              return false;
            }
            _that.NECaptchaValidate = data.validate;
            _that.getPhoneCode();
          })
        } else {
          Toast(result.errMsg);
        }
        this.verifycodeBtnText = "发送验证码";
        return false;
      }
      this.getCodeState = false;
      Toast('验证码已发出');
      this.cid = result.data.cid;
      this.verifycodeBtnText = `重发${codeTime}`;
      let timerId = setInterval(() => {
        codeTime--;
        if (codeTime <= 0) {
          this.verifycodeBtnText = "重新获取";
          clearInterval(timerId);
          return;
        }
        this.verifycodeBtnText = `重发${codeTime}`;
      }, 1000);
      setTimeout(() => {
          this.getCodeState = true;
      }, codeTime * 1000);
    },
    async getAllGift() {
      if (!this.userInfo) {
        Toast("抱歉,无法获取用户信息");
        this.loadingFlag = '2';
        return false;
      };
      this.loadingFlag = '1';
      let params = {
        luckActId: this.actInfo.id,
        phone: this.userInfo.phone
      };
      try {
        let { data: result } = await this.$get("findLucyRecordByPhoneAndAct", params);
        if (result.code !== 200) return Toast(result.errMsg);
        this.myGifttAll = result.data;
        if (this.myGifttAll.length) {
          this.loadingFlag = '0';
        } else {
          this.loadingFlag = '2';
        }
      } catch (err) {
        console.log(err);
      }
    },
    // 点击查看：
    async goLook() {
      const toastLoading = Toast.loading({
        message: "正在加载",
        forbidClick: true,
        duration: 0
      });
      if (this.userInfo.hasOwnProperty('token')) {
        let url = ""
        if (this.getGroundMarketingInfo.source) {
          url = this.$linkURL + 'my/coupon/list' + '/?receiveinfo=' + encodeToUrl({ token: this.userInfo.token}) + '&utm_source=' + this.getGroundMarketingInfo.source;
        } else {
          url = this.$linkURL + 'my/coupon/list' + '/?receiveinfo=' + encodeToUrl({ token: this.userInfo.token});
        }
        top.window.location.href = url;
      } else {
        toastLoading.clear();
        this.dialogShow = true;
        this.phoneNumber = this.userInfo.phone;
      }
    },
    // 填写信息：
    toWritePage(val) {
      this.$router.push({ name: "address", query: { uid: val } });
    },
    toAddCard() {
      Toast("您好，将会自动加入您的卡包哦！");
    }
  },
  async created() {
    await this.init();
    document.title = this.actInfo.name;
    this.getAllGift();
  },
};
</script>

<style lang="scss" scoped>
/depp/.van-checkbox__icon--checked .van-icon {
    color: #fff;
    background-color: #1989fa;
    border-color: #1989fa;
}
/deep/.van-cell {
  width: 100%;
  height: 100%;
  // background-color: #f6f6f6;
  background-color: rgba(255, 255, 255, 0);
  line-height: 40px;
  padding-top: 0px;
  padding-bottom: 0px;
}
.home_container {
  width: 100%;
  height: 100%;
  background-size: 100% auto;
  background-repeat: no-repeat;
  padding-top: 20px;
  // position: fixed;
  // top: 0;
  // left: 0;
  .header_container {
    width: 100%;
    height: 50px;
    display: flex;
    position: fixed;
    top: 20px;
    left: 0;
    .logo {
      flex: 3;
      padding-left: 15px;
    }
    .centerBtn {
      flex: 2;
      padding-left: 10px;
    }
    .rightBtn {
      flex: 2;
      padding-left: 10px;
      .myGiftBtn {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: flex-end;
        .btn_inner {
          width: 80%;
          height: 25px;
          border-radius: 15px;
          font-size: 12px;
          text-align: center;
          line-height: 25px;
          // font-family: "方正粗圆";
        }
      }
    }
    .rightIcon {
      width: 30px;
      padding-left: 10px;
      padding-top: 5px;
      img {
        width: 50%;
      }
    }
  }
  .ruleTitle {
    width: 100%;
    min-height: 200px;
    position: relative;
    .onlyLine {
      width: 100%;
      height: 10px;
      img {
        width: 60%;
        margin-bottom: 7px;
      }
    }
    .onlyLine02 {
      width: 100%;
      height: 20px;
      margin: 0 auto;
      img {
        width: 60%;
      }
}
    .allOfOne {
      width: 90%;
      height: 165px;
      margin: 0 auto;
      border-radius: 10px;
      position: relative;
      margin-top: 15px;
      &:nth-of-type(1) {
        margin-top: 0px;
      }
      .content_containerBox {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        // margin-top: 15px;
        overflow: hidden;
        border-radius: 10px;
        // new css:
        .card_title {
            height: 50px;
            width: 100%;
            padding-top: 15px;
            padding-left: 15px;
            padding-right: 15px;
            // font-family: "方正粗圆";
        }
        .card_body {
          height: 100px;
          display: flex;
          .card_content {
            height: 100px;
            text-align: center;
            // background-color: #F6F6F6;
            display: flex;
            justify-content: center;
            align-items: center;
            img {
              width: 80%;
              height: 120%;
            }
          }
          .card_footer {
            height: 100px;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            padding: 0 15px;
            .card_footer_btn {
              width: 135px;
              height: 35px;
              text-align: center;
              line-height: 35px;
              border-radius: 20px;
              // font-family: "方正粗圆";
            }
          }
        }
      }
    }
  }
}

.loadingBox {
  width: 100%;
  height: 80px;
  text-align: center;
  .content_loadingBox {
    width: 100px;
    height: 100%;
    margin: 0 auto;
    img {
      width: 100%;
    }
  }
  
}

.allNull {
  width:100%;
  height: 90px;
  text-align: center;
  .content_loadingBox {
    width: 100px;
    height: 100%;
    margin: 0 auto;
    img {
    width: 50%;
  }
  }
}
.giftName_Box {
  width: 100%;
  height: 50px;
  font-size: 13px;
  overflow: hidden;
}

// 弹框样式：
.showBox_father {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 10;
  overflow: auto;
}

.showBox_son {
  width: 300px;
  height: 300px;
  // background-color: #fff;
  border-radius: 10px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
  display: flex;
  flex-direction: column;
  .dialogBox_inner {
    .dialogBox_inner_title {
      padding: 15px 20px 0;
      font-size: 18px;
      font-weight: bold;
      text-align: center;
    }
    .dialogBox_inner_input_box {
      padding: 20px;
      .new_content_input {
        height: 40px;
        background-color: rgba(255, 255, 255, .7);
        border-radius: 20px;
        .new_content_input_box_inner {
          width: 100%;
          height: 100%;
        }
        &:nth-of-type(2) {
          margin-top: 15px;
          display: flex;
          .new_content_input_box_inner {
            flex: 1;
          }
          .new_content_input_box_inner_getCodeBtn {
            width: 100px;
            height: 100%;
            line-height: 40px;
            text-align: center;
          }
        }

      }
    }
    .dialogBox_inner_footer {
      .checkbox_container {
        display: flex;
        justify-content: center;
        align-items: center;
        padding-bottom: 5px;
        font-size: 12px;
        .checkbox_container_btn {
          display: flex;
          justify-content: center;
          align-items: center;
          .no_active {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            margin-right: 5px;
          }
          .active {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            margin-right: 5px;
            display: flex;
            justify-content: center;
            align-items: center;
            .iconfont {
              font-size: 8px;
            }
          }
        }
        .checkbox_container_text {
        }
      }
      .btn_container {
        display: flex;
        justify-content: space-around;
        padding: 10px 20px 0;
        .btn_inner {
          width: 120px;
          height: 30px;
          border-radius: 15px;
          font-size: 14px;
          text-align: center;
          line-height: 30px;
        }
      }
    }

  }
}
// 弹框动画：
.myself-dialog-fade-enter-active {
  animation: dialog-fadein 0.4s;
  .showBox_son {
    animation: dialog-zoom 0.4s;
  }
}

.myself-dialog-fade-leave-active {
  animation: dialog-fadeout 0.4s;
  .showBox_son {
    animation: dialog-out 0.4s;
  }
}

@keyframes dialog-fadein {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@keyframes dialog-fadeout {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}

@keyframes dialog-zoom {
  0% {
    transform: translate(-50%, -50%) scale(0);
  }

  50% {
    transform: translate(-50%, -50%) scale(1.1);
  }

  100% {
    transform: translate(-50%, -50%) scale(1);
  }
}

@keyframes dialog-out {
  0% {
    transform: translate(-50%, -50%) scale(1);
  }

  50% {
    transform: translate(-50%, -50%) scale(1.1);
  }

  100% {
    transform: translate(-50%, -50%) scale(0);
  }
}

.showBox_son_by_user {
  height: 500px;
  .showBox_son_by_user_content {
    height: 450px;
    width: 100%;
    padding-bottom: 15px;
    iframe {
      height: 450px;
      width: 100%;
      color: red;
    }
  }
  .showBox_son_by_user_btn {
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    .btn_inner {
      width: 120px;
      height: 30px;
      border-radius: 15px;
      font-size: 14px;
      text-align: center;
      line-height: 30px;
    }
  }
}
</style>
